require("!!/Users/mattijsnaus/Documents/code/pagestead/node_modules/script-loader/addScript.js")(require("!!/Users/mattijsnaus/Documents/code/pagestead/node_modules/raw-loader/index.js!/Users/mattijsnaus/Documents/code/pagestead/assets/js/vendor/froala_editor_sources_2/js/plugins/paragraph_format.min.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./assets/js/vendor/froala_editor_sources_2/js/plugins/paragraph_format.min.js
// module id = 68
// module chunks = 0